// extracted by mini-css-extract-plugin
module.exports = {"page":"CertifyUser_page_3x42G","action_btn":"CertifyUser_action_btn_gd9rT","goBack":"CertifyUser_goBack_32cbZ"};